import { createFileRoute, redirect } from '@tanstack/react-router'

import {
  BillingBlocked,
  OperationalBlockedActions,
} from '#components/features/billing/billing-access'
import { KitchenBoard } from '#components/features/orders/kitchen-board'
import { WorkspaceLoadingSkeleton } from '#components/layout/workspace-loading-skeleton'
import { useLogoutWaiter } from '#hooks/api/use-auth-actions'
import { useBillingAccess } from '#hooks/api/use-billing-access'
import { useWaiterStore } from '#stores/use-waiter-store'

export const Route = createFileRoute('/cozinha')({
  beforeLoad: () => {
    const member = useWaiterStore.getState().waiter
    if (
      !localStorage.getItem('@usecomanda:waiter_token') ||
      member?.role !== 'kitchen' ||
      member.is_active === false
    )
      throw redirect({ to: '/garcom' })
  },
  head: () => ({
    meta: [
      { title: 'Cozinha | UseComanda' },
      {
        name: 'description',
        content: 'Acompanhe e avance os pedidos em preparo.',
      },
    ],
  }),
  component: KitchenPage,
})

function KitchenPage() {
  const member = useWaiterStore((state) => state.waiter)
  const billing = useBillingAccess(member?.tenant_id)
  const { handleLogout } = useLogoutWaiter()
  if (billing.isLoading) return <WorkspaceLoadingSkeleton />
  if (!billing.accessState.canOperate)
    return (
      <BillingBlocked
        state={billing.accessState}
        actions={<OperationalBlockedActions onLogout={handleLogout} />}
      />
    )
  return <KitchenBoard />
}
